import { Component, OnInit, ChangeDetectorRef, ViewChild, ViewRef } from '@angular/core';
import { SelectionGenericService } from '../../services/selection-generic.service';
import { LeaveGenericDataModel } from '../../entities/leave-generic-data-model';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-leave-panel',
    templateUrl: './leave-panel.component.html',
    styleUrls: ['./leave-panel.component.scss'],
    standalone: false
})
export class LeavePanelComponent implements OnInit {

  commentText: string;
  showSeemore: boolean;
  isBlockedEmployee = false;
  leaveGenericDataModel: LeaveGenericDataModel;
  isExistLeave = false;
  isLoadingLeavePanel = false;

  @ViewChild('commentSpan') commentSpan: any;

  constructor(
    public cdRef: ChangeDetectorRef, 
    public selectionService: SelectionGenericService,
    public sharedService: SharedService) {
    this.leaveGenericDataModel = new LeaveGenericDataModel();
    this.commentText = '';
    this.subscribeEvents();
  }

  ngOnInit(): void {
  }

  subscribeEvents(): any {
    this.selectionService.rowDataForLeaveReport.subscribe((res) => {
      this.leaveGenericDataModel = new LeaveGenericDataModel();
      if (res) {
        if (res.bloqueado === 'S') {
          this.isBlockedEmployee = true;
        }
        else {
          this.isBlockedEmployee = false;
          const leaveId = res.bajaId === undefined ? 0 : res.bajaId;
          this.getGeneralLeaveData(res.trabajadorId, leaveId);
        }
      } else {
        this.resetLeaveCard();
      }
    });
  }

  resetLeaveCard(): void {
    this.commentText = '';
    this.showSeemore = undefined;
    this.isBlockedEmployee = false;
    this.leaveGenericDataModel = new LeaveGenericDataModel();
    this.isExistLeave = false;
    this.isLoadingLeavePanel = false;
    if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
      this.cdRef.detectChanges();
    }
  }

  clickSeeMore(action: any): void {
    action.displayComment = action.comentarios;
  }

  public ShowCompactText(comment: any, showLess: boolean): any {
    if (comment.length > 115 && showLess) {
      return comment.substring(0, 114);
    }
    return comment;
  }

  private getGeneralLeaveData(empId, leaveId = 0): any {

    this.isLoadingLeavePanel = true;
    this.selectionService.getCurrentUserPermissions();
    this.selectionService.getGeneralLeaveData(empId).subscribe((res) => {
      if (res) {
        if (res.code === 0) {
          if (res.result.length > 0) {
            if (leaveId === 0) {
              this.leaveGenericDataModel = res.result[0];
            } else {
              this.leaveGenericDataModel = res.result.filter(e => e.bajaId === leaveId)[0];
            }

            this.leaveGenericDataModel.nivelArray = this.createArrayForCompanyLevel();
            this.leaveGenericDataModel.seniorityText = this.setSeniorityValue(this.leaveGenericDataModel.seniority);
            this.leaveGenericDataModel.attributeArray = this.createArrayForCompanyAttribute();
            if (this.leaveGenericDataModel.fbaja != null) {
              this.leaveGenericDataModel.leaveDaysArray = this.calculateLeaveDays();
            }
            this.leaveGenericDataModel.reciadaDayArray = this.leaveGenericDataModel.recaida == 'S' ? this.calculateReciadaDays(this.leaveGenericDataModel.leaveDaysArray[0]) : "";
            this.isExistLeave = true;
          }
          else {
            this.leaveGenericDataModel = new LeaveGenericDataModel();
            this.isExistLeave = false;
          }
        }
        else {
          this.selectionService.ShowSnackBar('No se pudieron cargar los datos de la baja', '', 2500);
        }
        this.isLoadingLeavePanel = false;
      }
    });
  }

  private createArrayForCompanyLevel(): any {
    this.leaveGenericDataModel.nivelArray = [];
    this.leaveGenericDataModel.nivelArray[0] = this.leaveGenericDataModel.nivel1;
    this.leaveGenericDataModel.nivelArray[1] = this.leaveGenericDataModel.nivel2;
    this.leaveGenericDataModel.nivelArray[2] = this.leaveGenericDataModel.nivel3;
    this.leaveGenericDataModel.nivelArray[3] = this.leaveGenericDataModel.nivel4;
    this.leaveGenericDataModel.nivelArray[4] = this.leaveGenericDataModel.nivel5;
    return this.leaveGenericDataModel.nivelArray.filter(x => x != null);
  }

  private setSeniorityValue(seniority?: number): string {
    let textvalue = '';
    if (this.leaveGenericDataModel.ffinContrato != null) {
      textvalue = 'Contrato Finalizado. ';
    }
    if (seniority != null) {
      switch (seniority) {
        case 0:
          textvalue = textvalue !== '' ? textvalue + 'Menos de un año de antigüedad' : 'Menos de un año de antigüedad';
          break;
        case 1:
          textvalue = textvalue !== '' ? textvalue + 'Un año de antigüedad' : 'Un año de antigüedad';
          break;
        default:
          textvalue = textvalue !== '' ? textvalue + seniority + ' años de antigüedad' : seniority + ' años de antigüedad';
          break;
      }
    }
    return textvalue;
  }

  private createArrayForCompanyAttribute(): any {
    this.leaveGenericDataModel.attributeArray = [];
    this.leaveGenericDataModel.attributeArray[0] = this.leaveGenericDataModel.atributo1;
    this.leaveGenericDataModel.attributeArray[1] = this.leaveGenericDataModel.atributo2;
    this.leaveGenericDataModel.attributeArray[2] = this.leaveGenericDataModel.atributo3;
    this.leaveGenericDataModel.attributeArray[3] = this.leaveGenericDataModel.atributo4;
    this.leaveGenericDataModel.attributeArray[4] = this.leaveGenericDataModel.atributo5;
    this.leaveGenericDataModel.attributeArray[5] = this.leaveGenericDataModel.atributo6;
    this.leaveGenericDataModel.attributeArray[6] = this.leaveGenericDataModel.atributo7;
    this.leaveGenericDataModel.attributeArray[7] = this.leaveGenericDataModel.atributo8;
    this.leaveGenericDataModel.attributeArray[8] = this.leaveGenericDataModel.atributo9;
    this.leaveGenericDataModel.attributeArray[9] = this.leaveGenericDataModel.atributo10;
    this.leaveGenericDataModel.attributeArray[10] = this.leaveGenericDataModel.atributo11;
    this.leaveGenericDataModel.attributeArray[11] = this.leaveGenericDataModel.atributo12;
    return this.leaveGenericDataModel.attributeArray.filter(x => x != null);
  }

  private calculateLeaveDays(): any {
    let dayDiff: number;
    const today = new Date();
    let leaveDayString = '';
    this.leaveGenericDataModel.leaveDaysArray = [];
    if (this.leaveGenericDataModel.falta != null) {
      dayDiff = Math.floor(DateHelper.getDateDifference(this.leaveGenericDataModel.fbaja, this.leaveGenericDataModel.falta));
    }
    else if (this.leaveGenericDataModel.fcierre != null) {
      dayDiff = Math.floor(DateHelper.getDateDifference(this.leaveGenericDataModel.fbaja, this.leaveGenericDataModel.fcierre));
    }
    else {
      dayDiff = Math.floor(DateHelper.getDateDifference(this.leaveGenericDataModel.fbaja, today.toISOString()));
      dayDiff = dayDiff + 1;
    }
    if (dayDiff > 1) {
      leaveDayString = dayDiff + ' días de baja';
    }
    else if (dayDiff === 1) {
      leaveDayString = dayDiff + ' día de baja';
    }
    this.leaveGenericDataModel.leaveDaysArray[0] = dayDiff;
    this.leaveGenericDataModel.leaveDaysArray[1] = leaveDayString;
    return this.leaveGenericDataModel.leaveDaysArray;
  }

  private calculateReciadaDays(leaveDay): any {
    let dayCalculated: number;
    let reciadaDayString = '';
    this.leaveGenericDataModel.reciadaDayArray = [];
    if (this.leaveGenericDataModel.acumuladoRecaida != null) {
      dayCalculated = leaveDay != null && leaveDay !== undefined ? leaveDay + this.leaveGenericDataModel.acumuladoRecaida : this.leaveGenericDataModel.acumuladoRecaida;
    }
    reciadaDayString = dayCalculated > 1 ? dayCalculated + ' días acumulados por recaída' : dayCalculated + ' día acumulados por recaída';
    this.leaveGenericDataModel.reciadaDayArray[0] = dayCalculated;
    this.leaveGenericDataModel.reciadaDayArray[1] = reciadaDayString;
    return this.leaveGenericDataModel.reciadaDayArray;
  }
}
